import classnames from "classnames";

import { Var } from "features/common/localisation";

import styles from "./Badge.module.scss";
import { Color, COLORS, Size, SIZES } from "./consts";

type Props = {
  count: number | null | undefined;
  loading?: boolean;
  className?: string;
  color?: Color | string;
  size?: Size | string;
};

export default function Badge({
  count,
  loading,
  className,
  color,
  size
}: Props) {
  const countLength = count?.toString().length;

  return (
    <Var>
      <div
        className={classnames(styles.badge, styles.sizeMedium, className, {
          [styles.loading]: loading,
          [styles.colorEcstasy]: !color || color === COLORS.ECSTASY,
          [styles.colorOrange]: color === COLORS.ORANGE,
          [styles.colorSkyBlue]: color === COLORS.SKYBLUE,
          [styles.colorPink]: color === COLORS.PINK,
          [styles.sizeMedium]: size === SIZES.MEDIUM,
          [styles.sizeSmall]: size === SIZES.SMALL,
          [styles.wide]: countLength && countLength > 1
        })}
      >
        {count || 0}
      </div>
    </Var>
  );
}
